<section class="vendorSection">
      <div class="row">
            <div class="col-md-12 imgRes" *ngIf="!!featureTags && !featureTags['sf_cms_images']">
                  <img src="https://hudsonmilk.com/images/3/cms/Hudson_Milk_Market-Get_Fresh_With_Us.png" alt="Get Fresh With Us">
           </div>
            <div class="col-md-12 imgRes" *ngIf="!!featureTags && featureTags['sf_cms_images']">
                   <img src="assets/hudson/files/images/3/content-images/Hudson_Milk_Market-Get_Fresh_With_Us.png" alt="Get Fresh With Us">
            </div>
     </div>
      <div fxLayout="row wrap" fxLayoutGap.gt-sm="15px">
            <div fxFlex="auto" 
            fxFlex.md="calc(50% - 15px)"
            fxFlex.gt-md="calc(33% - 15px)"  
            class="vendorList" 
            *ngFor="let vendor of vendors">
                  <div class="content-block">
                        <div class="proImg">
                              <a [routerLink]="vendorSelection(vendor)" (click)="vendorSelection(vendor)">
                                    <img *ngIf="!!vendor['vendor_logo']"  class="img-responsive" src="data:," [imgName]="vendor['vendor_logo']" 
                                    alt = "{{vendor['vendor_name']}}" imgType="vendors" imgSize="lg" imagePreload >
                                    <ng-container *ngIf="!!featureTags && featureTags['sf_vendor_page_2']">
                                          <ng-container *ngIf="!!featureTags && featureTags['sf_vendor_page_3']">
                                                <img *ngIf="vendor['vendor_logo'] === null || vendor['vendor_logo'] === ''"  class="img-responsive" src="assets/images/no_image.png"
                                                alt = "{{vendor['vendor_name']}}" imgType="vendors" imgSize="lg">
                                          </ng-container>
                                          <ng-container *ngIf="!!featureTags && !featureTags['sf_vendor_page_3']">
                                                <img *ngIf="vendor['vendor_logo'] === null || vendor['vendor_logo'] === ''"  class="img-responsive" src="...../assets/images/no_image_found_md.png" 
                                                alt = "{{vendor['vendor_name']}}" imgType="vendors" imgSize="lg" imagePreload >
                                          </ng-container>
                                    </ng-container>
                              </a>
                        </div>
                        <div class="subcat_content">
                              <ng-container *ngIf="!!featureTags && featureTags['sf_seo'];else ventorTitle">
                                    <h1><a class="Title" [routerLink]="vendorSelection(vendor)" (click)="vendorSelection(vendor)">{{vendor['vendor_name']}}</a></h1>
                              </ng-container>
                              <ng-template #ventorTitle>
                                    <a class="Title" [routerLink]="vendorSelection(vendor)" (click)="vendorSelection(vendor)">{{vendor['vendor_name']}}</a>
                              </ng-template>
                              <div class="pcontentDiv">
                                  <span 
                                    class="p_content" 
                                    *ngIf="!!featureTags && !featureTags['sf_vendor_page_2']" 
                                    [innerHTML]="vendor['vendor_description'] | limitWords">
                                  </span>
                                  <span 
                                    class="p_content" 
                                    *ngIf="!!featureTags && featureTags['sf_vendor_page_2']" 
                                    [innerHTML]="vendor.sanitizedDescription">
                                  </span>
                              </div>
                              <a class="btn btn-default btn-red hand" [routerLink]="vendorSelection(vendor)"
                               [class.selected]="vendor.selected">View Our Products</a>
                        </div>
                  </div>
            </div>
      </div>
</section>